const testimonialsData = [
    {
      image: "https://us.123rf.com/450wm/rawpixel/rawpixel1704/rawpixel170462225/76770585-african-descent-man-in-a-shoot.jpg?ver=6",
      name: "Menzi Khomo",
      rating: 5,
      review: "The food was absolutely delicious! The ambiance and service were perfect. Definitely coming back!"
    },
    {
      image: "https://images.unsplash.com/photo-1629145810320-aec9e63dd798?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      name: "Sophia Nzimande",
      rating: 3,
      review: "Amazing experience! The Greek Salad was fresh, and the service was top-notch."
    },
    {
      image: "https://images.pexels.com/photos/2743754/pexels-photo-2743754.jpeg?cs=srgb&dl=pexels-davdkuko-2743754.jpg&fm=jpg",
      name: "Philani Msomi",
      rating: 3.5,
      review: "Grilled fish was cooked to perfection! Loved every bite."
    },
    {
      image: "https://images.unsplash.com/photo-1584361853901-dd1904bb7987?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTJ8fGJsYWNrJTIwYW5kJTIwd2hpdGUlMjB3b21hbnxlbnwwfHwwfHx8MA%3D%3D",
      name: "Sukey Lee",
      rating: 4,
      review: "Best restaurant in town! The grilled fish was incredible."
    }
  ];
  
  export default testimonialsData;
  